module.exports = __webpack_public_path__ + "static/img/2.bc756eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/2.png
// module id = nez2
// module chunks = 0